export default __webpack_public_path__ + "i18n/translations/translation-es.c61dafcd.json";